import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Icon.module.scss'

const propTypes = {
  // modify the color
  color: PropTypes.oneOf([
    'blue',
    'danger',
    'green',
    'negative',
    'orange',
    'pink',
    'positive',
    'quiet',
    'red',
    'success',
    'warning',
    'white'
  ])
}

const rootProps = ({ className, color, ...restProps }) => ({
  className: classnames(styles.icon, styles[`color-${color}`], className),
  ...restProps
})

const Icon = props => <i {...rootProps(props)} />
Icon.propTypes = propTypes
Icon.className = styles.icon

export default Icon
